import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { BACKEND_URL } from '../config';
import PackageView from '../components/site/PackageView';
import { SitePage, PageHero, PageLoading } from '../components/site/ui';

// Same slug rule as the backend
const slugify = (title, id) => {
  if (!title) return `package-${id}`;
  const s = title.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/[\s_]+/g, '-').replace(/-+/g, '-').replace(/^-+|-+$/g, '');
  return s ? `${s}-${id}` : `package-${id}`;
};

/** /package/:slug — accepts a package id or an SEO slug. */
const PackageDetail = () => {
  const { slug } = useParams();
  const [pkg, setPkg] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    axios.get(`${BACKEND_URL}/api/packages`)
      .then((r) => {
        const list = Array.isArray(r.data) ? r.data : [];
        const found = list.find((p) => String(p.id) === slug || p.slug === slug || slugify(p.title, p.id) === slug) || null;
        if (alive) setPkg(found);
      })
      .catch(() => { if (alive) setPkg(null); })
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [slug]);

  if (loading) return <PageLoading />;
  if (!pkg) {
    return (
      <SitePage>
        <PageHero short title="Package" accent="not found" lede="This package may have been updated or removed. Browse our current packages or ask us for a custom plan.">
          <Link className="vk-btn vk-btn--hot" to="/tour-packages">See all packages</Link>
        </PageHero>
      </SitePage>
    );
  }
  return <PackageView pkg={pkg} destinationId={pkg.destination} canonicalPath={`/destination/${(pkg.destination || '').toLowerCase()}/package/${pkg.id}`} />;
};

export default PackageDetail;
